<template>
	<div style="min-width: 1000px">
		<vs-popup
			:active.sync="showValidatePopup"
			title="Souhaitez-vous vraiment remplacer la date de facturation de ces achats ?"
		>
			<div
				style="
					padding: 20px;
					display: flex;
					flex-direction: column;
					align-items: center;
				"
			>
				<h3>
					Sélectionnez les achat dont vous souhaitez remplacer la date de
					facturation, puis validez.
				</h3>
				<div class="vx-row" style="margin-top: 20px">
					<vs-table :data="tmpValidateList" class="w-full">
						<template slot="thead">
							<vs-th style="text-align: center">
								<label class="form-checkbox">
									<input
										type="checkbox"
										style="margin: 0 5px 0 5px"
										v-model="selectAll"
										@click="selectValidate()"
									/>
								</label>
							</vs-th>
							<vs-td class="text-center">Société</vs-td>
							<vs-td class="text-center">Contrat N°</vs-td>
							<vs-td class="text-center">Service</vs-td>
							<vs-td class="text-center">Prestataire</vs-td>
							<vs-td class="text-center">Prix</vs-td>
						</template>
						<template slot-scope="{ data }">
							<vs-tr :key="index" v-for="(currentPurchase, index) in data">
								<vs-td style="text-align: center">
									<label class="form-checkbox">
										<input
											type="checkbox"
											:value="currentPurchase.id"
											v-model="selected"
										/>
									</label>
								</vs-td>
								<vs-td class="text-center">{{
									currentPurchase.society_name
								}}</vs-td>
								<vs-td class="text-center">{{
									currentPurchase.contract_id
								}}</vs-td>
								<vs-td class="text-center">{{
									getServiceIdToName(currentPurchase.service_id)
								}}</vs-td>
								<vs-td class="text-center">{{
									getProviderIdToName(currentPurchase.users_id)
								}}</vs-td>
								<vs-td class="text-center">{{
									currentPurchase.recurrence_date
										? convertInternationalNumberToFrenchCurrency(
												currentPurchase.recurrence_price
										  )
										: convertInternationalNumberToFrenchCurrency(
												currentPurchase.price
										  )
								}}</vs-td>
							</vs-tr>
						</template>
					</vs-table>
				</div>
				<div
					class="vx-row w-full flex"
					style="justify-content: center"
					id="txt"
				></div>
				<div class="vx-row" style="margin-top: 20px">
					<div class="text-right">
						<vs-button color="primary" @click="validateList()"
							>Valider</vs-button
						>
					</div>
				</div>
			</div>
		</vs-popup>
		<vs-popup
			:active.sync="showDatePopup"
			:title="`Saisissez la date de facturation${
				currentPurchase && currentPurchase.society_name
					? ' pour ' + currentPurchase.society_name
					: ''
			}.`"
		>
			<div v-if="currentPurchase">
				<div class="vx-row">
					<div class="vx-col">
						{{ currentPurchase.society_name }}
					</div>
					<div class="vx-col">Contrat N°{{ currentPurchase.contract_id }}</div>
					<div class="vx-col">
						{{ getServiceIdToName(currentPurchase.service_id) }}
					</div>
					<div class="vx-col">
						{{ getProviderIdToName(currentPurchase.users_id) }}
					</div>
					<div class="vx-col">
						{{
							currentPurchase.recurrence_date
								? convertInternationalNumberToFrenchCurrency(
										currentPurchase.recurrence_price
								  )
								: convertInternationalNumberToFrenchCurrency(
										currentPurchase.price
								  )
						}}
					</div>
				</div>
				<div
					class="vx-row w-full flex"
					style="justify-content: center"
					id="txt"
				></div>
				<div class="vx-row mt-4">
					<div class="vx-col w-1/2">
						<vx-input-group class="mb-6">
							<flat-pickr
								class="w-full"
								v-model="currentPurchaseInvoiceDateTemp"
								placeholder="Date de facturation"
								:config="configDatePicker"
							/>
							<template slot="append">
								<div class="append-text btn-addon">
									<vs-button color="primary" @click="resetInvoiceDate()"
										>X</vs-button
									>
								</div>
							</template>
						</vx-input-group>
					</div>
					<div class="vx-col w-1/2">
						<vs-button color="primary" class="w-full" @click="saveInvoiceDate()"
							>Enregistrer</vs-button
						>
					</div>
				</div>
			</div>
			<div v-if="!currentPurchase">
				<div class="vx-row">
					<vs-table :data="currentPurchases" class="w-full">
						<template slot-scope="{ data }">
							<vs-tr :key="index" v-for="(currentPurchase, index) in data">
								<vs-td class="text-center">{{
									currentPurchase.society_name
								}}</vs-td>
								<vs-td class="text-center"
									>Contrat N°{{ currentPurchase.contract_id }}</vs-td
								>
								<vs-td class="text-center">{{
									getServiceIdToName(currentPurchase.service_id)
								}}</vs-td>
								<vs-td class="text-center">{{
									getProviderIdToName(currentPurchase.users_id)
								}}</vs-td>
								<vs-td class="text-center">{{
									currentPurchase.recurrence_date
										? convertInternationalNumberToFrenchCurrency(
												currentPurchase.recurrence_price
										  )
										: convertInternationalNumberToFrenchCurrency(
												currentPurchase.price
										  )
								}}</vs-td>
							</vs-tr>
						</template>
					</vs-table>
				</div>
				<div
					class="vx-row w-full flex"
					style="justify-content: center"
					id="txt"
				></div>
				<div class="vx-row mt-4">
					<div class="vx-col w-1/2">
						<vx-input-group class="mb-6">
							<flat-pickr
								class="w-full"
								v-model="currentPurchaseInvoiceDateTemp"
								placeholder="Date de facturation"
								:config="configDatePicker"
							/>
							<template slot="append">
								<div class="append-text btn-addon">
									<vs-button color="primary" @click="resetInvoiceDate()"
										>X</vs-button
									>
								</div>
							</template>
						</vx-input-group>
					</div>
					<div class="vx-col w-1/2">
						<vs-button
							color="primary"
							class="w-full"
							@click="
								tmpValidateList.length > 0
									? (showValidatePopup = true)
									: saveInvoiceDateForAll()
							"
							>Enregistrer</vs-button
						>
					</div>
				</div>
			</div>
		</vs-popup>
		<vs-table
			noDataText=""
			:data="displayedPurchases"
			stripe
			auto-resize
			class="w-full screen_size"
			id="provider-table"
		>
			<template slot="thead">
				<vs-th class="th-sticky" style="width: 50px;"></vs-th>
				<vs-th class="th-sticky">Prestataire</vs-th>
				<vs-th class="th-sticky"><vs-spacer />Total Achat (HT)</vs-th>
				<vs-th class="th-sticky" v-if="$acl.check('financeadmin')"
					><div class="w-full text-center">Rapprochement de facture</div></vs-th
				>
			</template>

			<template>
				<vs-tr :key="index" v-for="(purchase, index) in displayedPurchases">
					<vs-td class="text-center" style="width: 50px;">
						<vs-button
							size="small"
							type="flat"
							@click="togglePurchaseExpand(index)"
							class="expand-btn"
						>
							<i class="material-icons">
								{{ expandedPurchases[index] ? 'expand_less' : 'expand_more' }}
							</i>
						</vs-button>
					</vs-td>
					<vs-td :data="purchase.users_id">
						{{ getProviderIdToName(purchase.provider_id) }}</vs-td
					>
					<vs-td :data="purchase.price" class="text-right">
						{{
							convertInternationalNumberToFrenchCurrency(purchase.totalAmount)
						}}</vs-td
					>
					<vs-td v-if="$acl.check('financeadmin')" class="text-center">
						<vs-button
							v-if="purchase.dateAll"
							class="material-icons myBtnPrimary"
							@click="displayDatePopup(purchase.number)"
							>fact_check</vs-button
						>
						<vs-button
							v-else
							class="material-icons myBtn"
							border
							style="color: orange"
							@click="displayDatePopup(purchase.number)"
							>preview</vs-button
						>
					</vs-td>
				</vs-tr>
				<tr v-if="expandedPurchases[index]" :key="'expand-' + index" class="expand-row">
					<td :colspan="$acl.check('financeadmin') ? 4 : 3" style="padding: 0;">
						<div style="width: 100%; display: flex">
							<vs-table
								:data="purchase.contracts"
								stripe
								pagination
								:max-items="15"
								:max-height="tableHeight + 'px'"
								class="w-full"
							>
								<template slot="thead">
									<vs-th style="width: 50px;"></vs-th>
									<vs-th class="text-left w-1/5">Société</vs-th>
									<vs-th
										class="text-center w-1/5"
										style="width: 130px"
										sort-key="id"
										>Numéro de contrat</vs-th
									>
									<vs-th class="text-center w-3/5">Total HT</vs-th>
								</template>

								<template slot-scope="{ data }">
									<vs-tr :key="contractIndex" v-for="(item, contractIndex) in data">
										<vs-td class="text-center" style="width: 50px;">
											<vs-button
												size="small"
												type="flat"
												@click="toggleContractExpand(index, contractIndex)"
												class="expand-btn"
											>
												<i class="material-icons">
													{{ expandedContracts[index + '-' + contractIndex] ? 'expand_less' : 'expand_more' }}
												</i>
											</vs-button>
										</vs-td>
										<vs-td class="text-left">{{
											getSocietyNameFromContractId(item.id)
										}}</vs-td>
										<vs-td class="text-left">{{ item.id }}</vs-td>
										<vs-td class="text-left">{{
											getTotalFromContractId(item)
										}}</vs-td>
									</vs-tr>
									<tr v-if="expandedContracts[index + '-' + contractIndex]" :key="'contract-expand-' + index + '-' + contractIndex" class="expand-row">
										<td colspan="4" style="padding: 0;">
											<div style="width: 100%; display: flex">
												<vs-table
													:data="item.detail"
													stripe
													pagination
													:max-items="15"
													auto-resize
													class="w-full thead-service"
												>
													<template slot="thead">
														<vs-th style="text-align: center">
															<label class="form-checkbox">
																<input
																	type="checkbox"
																	style="margin: 0 5px 0 5px"
																	v-model="item.selectAll"
																	@click="select(purchase.number, item.number)"
																/>
															</label>
														</vs-th>
														<vs-th class="text-center">Service</vs-th>
														<vs-th class="text-center">Prix Achat (HT)</vs-th>
														<vs-th class="text-center">Date de Saisie</vs-th>
														<vs-th class="text-center">Date Achat</vs-th>
														<vs-th class="text-center">Récurrence</vs-th>
														<vs-th class="text-center"
															>Est un achat récurrent ?</vs-th
														>
														<vs-th class="text-center">Facturable</vs-th>
														<vs-th class="text-center">Commentaire</vs-th>
														<vs-th class="text-center">Période</vs-th>
														<vs-th
															v-if="$acl.check('financeadmin')"
															class="text-center"
															>Rapprochement facture</vs-th
														>
													</template>

													<template slot-scope="{ data }">
														<vs-tr :key="detailIndex" v-for="(i, detailIndex) in data">
															<vs-td style="text-align: center">
																<label class="form-checkbox">
																	<input
																		:class="
																			'selection' +
																			purchase.number +
																			'/' +
																			item.number
																		"
																		type="checkbox"
																		:value="i.id"
																		v-model="item.selected"
																	/>
																</label>
															</vs-td>
															<vs-td :data="i.service_id" class="text-center">{{
																getServiceIdToName(i.service_id)
															}}</vs-td>
															<vs-td :data="i.price" class="text-right">
																{{
																	i.recurrence_date
																		? convertInternationalNumberToFrenchCurrency(
																				i.recurrence_price
																		  )
																		: convertInternationalNumberToFrenchCurrency(
																				i.price
																		  )
																}}</vs-td
															>
															<vs-td :data="i.input_date" class="text-center">
																{{
																	i.recurrence_date
																		? getDateToFrenchFormat(
																				formatDate(i.recurrence_date)
																		  )
																		: getDateToFrenchFormat(
																				formatDate(i.input_date)
																		  )
																}}</vs-td
															>
															<vs-td :data="i.bought_at" class="text-center">
																{{
																	i.recurrence_date
																		? getDateToFrenchFormat(
																				formatDate(i.recurrence_date)
																		  )
																		: getDateToFrenchFormat(
																				formatDate(i.bought_at)
																		  )
																}}</vs-td
															>
															<vs-td :data="i.recurrence" class="text-center">
																{{ getPurchaseFrequency(i.recurrence) }}</vs-td
															>
															<vs-td
																:data="i.recurrence_date"
																class="text-center"
															>
																{{ i.recurrence_date ? "Oui" : "Non" }}</vs-td
															>
															<vs-td :data="i.is_billable" class="text-center">
																{{
																	getUserDashboardAccess(i.is_billable)
																}}</vs-td
															>
															<vs-td :data="i.commentary" class="text-center">
																{{ i.commentary }}</vs-td
															>
															<vs-td :data="i.period_date" class="text-center">
																{{
																	i.period_date
																		? getMonthName(
																				new Date(i.period_date)
																		  ).replace(/^\S/, (s) => s.toUpperCase()) +
																		  " " +
																		  i.period_date.substr(0, 4)
																		: ""
																}}</vs-td
															>
															<vs-td
																v-if="$acl.check('financeadmin')"
																:data="i.commentary"
																class="text-center"
															>
																<vx-tooltip
																	v-if="i.invoice_date"
																	:text="formatInputDate(i.invoice_date)"
																	><vs-button
																		class="material-icons myBtnPrimary"
																		@click="
																			displayInvoiceDatePopup(
																				i,
																				purchase.number
																			)
																		"
																		>fact_check</vs-button
																	></vx-tooltip
																>
																<vs-button
																	v-else
																	class="material-icons myBtn"
																	border
																	style="color: orange"
																	@click="
																		displayInvoiceDatePopup(i, purchase.number)
																	"
																	>preview</vs-button
																>
															</vs-td>
														</vs-tr>
													</template>
												</vs-table>
												<vs-button
													v-if="$acl.check('financeadmin')"
													color="primary"
													style="max-width: 150px"
													@click="
														editFacturationDate(purchase.number, item.number)
													"
													>Saisir la date de facturation</vs-button
												>
											</div>
										</td>
									</tr>
								</template>
							</vs-table>
						</div>
					</td>
				</tr>
			</template>
		</vs-table>
	</div>
</template>

<script>
import Vue from "vue";
import store from "@/store/store";
import utilsMixin from "@/mixins/utilsMixin.js";
import dbFieldConvertorMixin from "@/mixins/dbFieldConvertorMixin.js";
import Purchase from "@/entities/Purchase";
import ValidationPopup from "@/components/popups/ValidationPopup";
import ContractInfo from "@/components/forms/contract/ContractInfo";

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
	name: "PurchasesTableRecapProviders",
	props: {
		purchases: Array,
		apiUrl: String,
		// services: Array,
	},
	mixins: [utilsMixin, dbFieldConvertorMixin],
	components: {
		flatPickr,
		ContractInfo,
	},
	data() {
		return {
			apiErrorMsg: null, // catching api error message
			purchaseToDelete: null,
			displayedPurchases: [],
			providerPurchasesDetail: [],
			selectedContract: null,
			contractsSocietiesWithName: null,
			//FILTERS
			providerFilter: null,
			recurrenceFilter: null,
			dateFromFilter: null,
			dateToFilter: null,
			configDatePicker: {
				dateFormat: "d/m/Y",
			},
			selected: [],
			selectAll: false,
			showValidatePopup: false,
			showDatePopup: false,
			currentPurchase: null,
			currentPurchases: [],
			currentPurchaseInvoiceDateTemp: null,
			tmpValidateList: [],
			tmpNum: "",
			tmpNumber: "",
			expandedPurchases: {},
			expandedContracts: {},
		};
	},
	created() {
		this.getAllSocietiesContractsWithName();
		this.getAllSocieties();
		this.getAllProviders();
		this.getAllServices();
		this.getLastMonthFromToDate();
		this.displayProvidersPurchases(this.dateFromFilter, this.dateToFilter);
	},
	mounted() {
		store.dispatch(
			"updateTableHeight",
			this.windowHeigth -
				this.horizentalNavBarHeight -
				this.filterCardHeight -
				0.1 * this.windowHeigth
		);
		this.$nextTick(() => {
			window.addEventListener("resize", () => {
				store.dispatch(
					"updateTableHeight",
					this.windowHeigth -
						this.horizentalNavBarHeight -
						this.filterCardHeight -
						0.1 * this.windowHeigth
				);
			});
		});
	},
	computed: {
		filterCardHeight: () => {
			return store.state.filterCardHeight;
		},
		isFilterDown: () => {
			return store.state.isFilterDown;
		},
		horizentalNavBarHeight: () => {
			return store.state.horizentalNavBarHeight;
		},
		windowHeigth: () => {
			return store.state.windowHeigth;
		},
		tableHeight: () => {
			return store.state.tableHeight;
		},
		societies: () => {
			return store.state.societies;
		},
		providers: () => {
			return store.state.providers;
		},
		services: () => {
			return store.state.services;
		},
	},
	watch: {
		isFilterDown: function () {
			store.dispatch(
				"updateFilterCardHeight",
				document.getElementById("fliterCard").clientHeight
			);
			store.dispatch(
				"updateTableHeight",
				this.windowHeigth -
					this.horizentalNavBarHeight -
					this.filterCardHeight -
					0.01 * this.windowHeigth
			);
		},
		purchases: function () {
			this.displayProvidersPurchases(null, null);
		},
	},

	methods: {
		displayDatePopup(num) {
			this.tmpValidateList = [];
			this.currentPurchase = false;
			this.tmpNum = num;
			this.tmpNumber = null;
			this.currentPurchases = this.purchases.filter(
				(purchase) =>
					purchase.users_id == this.displayedPurchases[num].provider_id
			);
			this.tmpValidateList = this.currentPurchases.filter(
				(purchase) => purchase.invoice_date !== null
			);
			this.showDatePopup = true;
		},
		displayInvoiceDatePopup(purchase, num) {
			this.tmpNum = num;
			this.currentPurchase = purchase;
			this.currentPurchaseInvoiceDateTemp = purchase.invoice_date
				? this.formatInputDate(purchase.invoice_date)
				: null;
			this.showDatePopup = true;
		},
		editFacturationDate(num, number) {
			this.tmpValidateList = [];
			if (this.displayedPurchases[num].contracts[number].selected.length > 0) {
				this.tmpNum = num;
				this.tmpNumber = number;
				this.currentPurchases = this.purchases.filter((purchase) => {
					return (
						this.displayedPurchases[num].contracts[number].selected.indexOf(
							purchase.id
						) > -1
					);
				});
				this.showDatePopup = true;
			}
		},
		findSocietyName(contractsSocietiesWithName, contract_id) {
			let foundSociety = contractsSocietiesWithName
				? contractsSocietiesWithName.findIndex(
						(row) => row.contract_id == contract_id
				  )
				: -1;
			if (foundSociety >= 0) {
				return contractsSocietiesWithName[foundSociety].society_name;
			}
			return "";
		},
		formatInputDate(input_date) {
			let formatedDate = input_date;
			if (input_date && input_date.length > 10)
				formatedDate = input_date.substring(0, 10);
			if (formatedDate.split(" ").length > 0)
				formatedDate = formatedDate.split(" ")[0];
			if (formatedDate.split("-").length > 0)
				formatedDate = formatedDate.split("-").reverse().join("/");
			return formatedDate;
		},
		getAllSocietiesContractsWithName() {
			return new Promise((resolve, reject) => {
				this.$http
					.get(this.apiUrl + "contract/getscn")
					.then((res) => {
						this.contractsSocietiesWithName = res.data;
						resolve(res.data);
					})
					.catch((err) => {
						//console.log("getAllSocietiesContractsWithName", this.apiUrl + "contract/getscn", err);
						reject(err);
					});
			});
		},
		getServiceIdToName(service_id) {
			let service_name = "";
			let service = this.services.find((service) => service.id == service_id);
			if (service != undefined && service.name != undefined) {
				service_name = service.name;
			}
			return service_name;
		},
		getProviderIdToName(provider_id) {
			let provider_name = "";
			let provider = this.providers.find(
				(provider) => provider.id == provider_id
			);
			if (provider != undefined && provider.society != undefined) {
				provider_name = provider.society;
			}
			return provider_name;
		},
		getSocietyNameFromContractId(contract_id) {
			// //console.log(contract_id)
			if (this.contractsSocietiesWithName) {
				return this.findSocietyName(
					this.contractsSocietiesWithName,
					contract_id
				);
			} else {
				this.getAllSocietiesContractsWithName().then((data) => {
					return this.findSocietyName(data, contract_id);
				});
			}
		},
		getTotalFromContractId(item) {
			let tmpPurchases = item.detail.filter(
				(purchase) => purchase.contract_id == item.id
			);
			let price = 0;
			for (let p of tmpPurchases) {
				p.recurrence_date ? (price += p.recurrence_price) : (price += p.price);
			}
			return this.convertInternationalNumberToFrenchCurrency(price);
		},
		formatToFrenchDateString(date) {
			// //console.log("formatToFrenchDateString", date);
			if (date.split("/").length > 1) {
				// //console.log("formatToFrenchDateString if", date);
				return date;
			} else {
				let objDate = new Date(this.formatToInternationalDateString(date));
				objDate.setDate(objDate.getDate() + 1);
				// //console.log("formatToFrenchDateString else", objDate.toISOString().substring(0, 10).split("-").reverse().join("/"));
				return date
					? objDate
							.toISOString()
							.substring(0, 10)
							.split("-")
							.reverse()
							.join("/")
					: "";
			}
		},

		formatToInternationalDateString(date) {
			if (date.split("/").length > 1) {
				let strDate = date.split("/").reverse().join("-");
				return strDate;
			} else {
				return date;
			}
		},

		getLastMonthFromToDate() {
			let today = new Date(Date.now());
			let year =
				today.getMonth() - 1 < 0
					? Number(today.getFullYear()) - 1
					: today.getFullYear();
			let month = today.getMonth() - 1 < 0 ? 11 : today.getMonth();
			// let day = today.getDate()
			this.dateFromFilter = new Date(year, month, 1).toISOString();
			this.dateToFilter = new Date(
				today.getFullYear(),
				today.getMonth(),
				0
			).toISOString();
			/*
			 * //console.log(this.dateFromFilter)
			 * //console.log(this.dateToFilter)
			 */
		},

		displayProvidersPurchases(strFromDate, strToDate) {
			this.displayedPurchases = [];
			let fromDate = new Date("1111-01-01");
			let toDate = new Date("9999-12-31");
			// //console.log(fromDate, toDate)
			let displayedPurchases = [];
			for (let purchase of this.purchases) {
				/*
				 * let purchaseDate = purchase.recurrence_date ? purchase.recurrence_date.substring(0, 10) : purchase.bought_at.substring(0, 10);
				 * let purchaseDateObj = new Date(purchaseDate);
				 *  if(purchaseDateObj <= toDate && purchaseDateObj >= fromDate){
				 *  //console.log(purchaseDate, fromDate, toDate, purchaseDateObj);
				 */
				let foundPurchaseIndex = displayedPurchases.findIndex(
					(curr_purchase) => curr_purchase.provider_id == purchase.users_id
				);
				if (foundPurchaseIndex < 0) {
					displayedPurchases.push({
						provider_id: purchase.users_id,
						totalAmount: purchase.recurrence_date
							? purchase.recurrence_price
							: purchase.price,
						contracts: [
							{
								id: purchase.contract_id,
								detail: [purchase],
								selected: [],
								selectedAll: false,
								number: 0,
							},
						],
						dateAll: purchase.invoice_date ? true : false,
						number: displayedPurchases.length,
					});
				} else {
					displayedPurchases[foundPurchaseIndex].totalAmount =
						displayedPurchases[foundPurchaseIndex].totalAmount + purchase.price;
					if (
						displayedPurchases[foundPurchaseIndex].contracts.findIndex(
							(curr_contract) => curr_contract.id == purchase.contract_id
						) < 0
					) {
						displayedPurchases[foundPurchaseIndex].contracts.push({
							id: purchase.contract_id,
							detail: [purchase],
							selected: [],
							selectedAll: false,
							number: displayedPurchases[foundPurchaseIndex].contracts.length,
						});
					} else {
						displayedPurchases[foundPurchaseIndex].contracts[
							displayedPurchases[foundPurchaseIndex].contracts.findIndex(
								(curr_contract) => curr_contract.id == purchase.contract_id
							)
						].detail.push(purchase);
					}
					purchase.invoice_date
						? ""
						: (displayedPurchases[foundPurchaseIndex].dateAll = false);
				}
				// }
			}

			/*
			 * for(let i = 0; i < displayedPurchases.length; i++){
			 * 	let providerPurchasesDetail = this.purchases.filter(purchase => {
			 * 		let purchaseDate = purchase.recurrence_date ? purchase.recurrence_date : purchase.bought_at;
			 * 		purchaseDate = purchaseDate ? purchaseDate.substring(0, 10) : null;
			 * 		purchaseDate = purchaseDate ? new Date(purchaseDate) : null;
			 * 		if(purchase.users_id == displayedPurchases[i].provider_id && purchaseDate <= toDate && purchaseDate >= fromDate){
			 * 			return purchase;
			 * 		}
			 * 	});
			 */

			/*
			 * 	let check = true;
			 * 	for(let item of providerPurchasesDetail){
			 * 		if(item.invoice_date == null) {
			 * 			check = false;
			 * 			break;
			 * 		}
			 * 	}
			 */

			/*
			 * 	displayedPurchases[i]["number"] = i;
			 * 	displayedPurchases[i]["selected"] = [];
			 * 	displayedPurchases[i]["selectedAll"] = false;
			 * 	displayedPurchases[i]["dateAll"] = check;
			 * }
			 */

			this.displayedPurchases = displayedPurchases;
		},

		/**
		 * Return true if a filter has been set
		 * @return {Boolean} - Is filter set ?
		 */
		isFilterSet() {
			////console.log("isFilterSet BEGIN")
			if (
				this.contractNumberFilterOn ||
				this.dateFromFilterOn ||
				this.dateToFilterOn ||
				this.expertiseFilterOn ||
				this.providerFilterOn ||
				this.societyFilterOn ||
				this.recurrenceFilterOn
			)
				return true;
			return false;
		},

		/**
		 * Return list of filtered purchases A CHANGER
		 * @param {String} contractNumberFilter - Contract number filter search value
		 * @param {String} societyFilter - String to match in society name
		 * @param {String} recurrenceFilter - Recurrence's Frequency number filter search value
		 * @return {List} - Purchases' list filtered
		 */
		filterPurchases(purchases) {
			////console.log("filterProviders BEGIN")
			let purchasesList = [];

			let searchKeyList = {};
			this.dateFromFilterOn
				? (searchKeyList["dateFromFilter"] = new Date(
						this.dateFromFilter.split("/").reverse().join("-")
				  ))
				: false;
			this.dateToFilterOn
				? (searchKeyList["dateToFilter"] = new Date(
						this.dateToFilter.split("/").reverse().join("-")
				  ))
				: false;
			this.expertiseFilterOn
				? (searchKeyList["expertiseFilter"] = this.expertiseFilter)
				: false;
			this.societyFilterOn
				? (searchKeyList["societyFilter"] = this.societyFilter)
				: false;
			this.contractNumberFilterOn
				? (searchKeyList["contractNumberFilter"] =
						this.contractNumberFilter.toString())
				: false;
			this.providerFilterOn
				? (searchKeyList["providerFilter"] = this.providerFilter)
				: false;
			this.recurrenceFilterOn
				? (searchKeyList["recurrenceFilter"] = this.recurrenceFilter)
				: false;

			for (let purchaseToFilter of purchases) {
				/*
				 * //console.log(purchaseToFilter)
				 *  let society_name = this.getSocietyName(purchaseToFilter.contract_society_id)
				 */

				// if(society_name != "") society_name = society_name.toLowerCase()

				let purchaseSearchKeyList = {};
				let purchaseDate = purchaseToFilter.recurrence_date
					? purchaseToFilter.recurrence_date
					: purchaseToFilter.bought_at;
				let re = new RegExp("([T|Z])", "g");
				purchaseDate = purchaseDate ? purchaseDate.replace(re, " ") : null;
				purchaseDate = purchaseDate ? new Date(purchaseDate) : null;
				this.dateFromFilterOn
					? (purchaseSearchKeyList["dateFromFilter"] = purchaseDate)
					: false;
				this.dateToFilterOn
					? (purchaseSearchKeyList["dateToFilter"] = purchaseDate)
					: false;
				this.expertiseFilterOn
					? (purchaseSearchKeyList["expertiseFilter"] =
							purchaseToFilter.service_id)
					: false;
				this.societyFilterOn
					? (purchaseSearchKeyList["societyFilter"] =
							purchaseToFilter.contract_society_id)
					: false;
				this.contractNumberFilterOn
					? (purchaseSearchKeyList["contractNumberFilter"] =
							purchaseToFilter.contract_id.toString())
					: false;
				this.providerFilterOn
					? (purchaseSearchKeyList["providerFilter"] =
							purchaseToFilter.users_id)
					: false;
				this.recurrenceFilterOn
					? (purchaseSearchKeyList["recurrenceFilter"] =
							purchaseToFilter.recurrence)
					: false;

				let check = true;

				for (let key in searchKeyList) {
					/*
					 * //console.log("TYPE")
					 * //console.log(typeof purchaseSearchKeyList[key])
					 */
					if (typeof searchKeyList[key] == "string") {
						if (typeof purchaseSearchKeyList[key] == "string") {
							if (!purchaseSearchKeyList[key].includes(searchKeyList[key])) {
								check = false;
								break;
							}
						} else if (typeof purchaseSearchKeyList[key] == "object") {
							////console.log("Array")
							let checkLoop = false;
							for (let value of purchaseSearchKeyList[key]) {
								let service_name = this.getServiceIdToName(value).toLowerCase();
								/*
								 * //console.log(service_name)
								 * //console.log(searchKeyList[key])
								 */
								if (service_name.includes(searchKeyList[key])) {
									////console.log("checkLoop = true;")
									checkLoop = true;
								}
							}
							if (!checkLoop) {
								check = checkLoop;
								break;
							}
						}
					} else if (searchKeyList[key] instanceof Date) {
						if (key == "dateFromFilter") {
							// //console.log("dateFromFilter", searchKeyList[key].toISOString(), purchaseSearchKeyList[key].toISOString(), searchKeyList[key] <= purchaseSearchKeyList[key])
							check = searchKeyList[key] <= purchaseSearchKeyList[key];
						}
						if (key == "dateToFilter") {
							check = searchKeyList[key] >= purchaseSearchKeyList[key];
						}
						if (!check) break;
					} else {
						if (purchaseSearchKeyList[key] != searchKeyList[key] - 1) {
							check = false;
							break;
						}
					}
				}

				if (check) purchasesList.push(purchaseToFilter);
			}
			/*
			 * return result
			 * //console.log("filterProviders END")
			 */
			return purchasesList;
		},

		searchAndDisplay() {
			this.displayedPurchases = this.filterPurchases(
				this.displayedPurchasesFull
			);
		},

		/**
		 * Add prefix to url using the mixin
		 */
		getPrefixedUrl(url) {
			return this.urlPrefixAdder(url);
		},

		/**
		 * Returns service name from service id
		 * @param {Number} service_id - service id to retrieve name from
		 * @return {String} - name of service id
		 */
		getServiceIdToName(service_id) {
			let service_name = "";
			let service = this.services.find((service) => service.id == service_id);
			if (service != undefined && service.name != undefined) {
				service_name = service.name;
			}
			return service_name;
		},

		getSocietyIdToName(society_id) {
			let society_name = "";
			let society = this.societies.find((society) => society.id == society_id);
			if (society != undefined && society.name != undefined) {
				society_name = society.name;
			}
			return society_name;
		},

		getProviderIdToName(provider_id) {
			let provider_name = "";
			let provider = this.providers.find(
				(provider) => provider.id == provider_id
			);
			if (provider != undefined && provider.society != undefined) {
				provider_name = provider.society;
			}
			return provider_name;
		},

		formatDate(date_input) {
			if (date_input && date_input.length > 10) {
				return date_input.substring(0, 10);
			} else {
				return date_input;
			}
		},
		getAllServices() {
			this.$store.dispatch("getAllServices");
		},
		/**
		 * Get all societies in store states
		 */
		getAllSocieties() {
			this.$store.dispatch("getAllSocieties");
		},
		getAllProviders() {
			this.$store.dispatch("getAllProviders");
		},

		deletePurchase(purchase) {
			let purchaseToDelete = new Purchase(purchase);
			// //console.log(purchase)
			if (purchaseToDelete.recurrence_id) {
				purchaseToDelete.deleterc(
					purchaseToDelete.recurrence_id,
					(err, res) => {
						if (err)
							if (res) {
								//console.log(err);
								this.$emit("delete-line", purchase);
							}
					}
				);
			} else {
				purchaseToDelete.delete(purchaseToDelete.id, (err, res) => {
					if (err)
						if (res) {
							//console.log(err);
							this.$emit("delete-line", purchase);
						}
				});
			}
		},

		displayContractPopup(contractId) {
			// //console.log("displayContractPopup", contractId)
			this.selectedContract = contractId;
			this.$emit("contract-info-popup", contractId);
		},

		resetInvoiceDate() {
			this.currentPurchaseInvoiceDateTemp = null;
		},

		async saveInvoiceDate() {
			let txt = document.getElementById("txt");
			txt.innerHTML = "<b>Enregistrement en cours, veuillez patienter.</b>";
			try {
				await Purchase.updatePurchaseInvoiceDate(
					this.currentPurchase.id,
					this.currentPurchaseInvoiceDateTemp
				);
				this.currentPurchase.invoice_date = this.currentPurchaseInvoiceDateTemp
					? this.currentPurchaseInvoiceDateTemp.split("/").reverse().join("-") +
					  " 02:00:00"
					: null;

				let check = 0;
				for (let x of this.displayedPurchases[this.tmpNum].contracts) {
					for (let y of x.detail) {
						if (
							this.currentPurchaseInvoiceDateTemp &&
							this.currentPurchase.id == y.id
						)
							y.invoice_date =
								this.currentPurchaseInvoiceDateTemp
									.split("/")
									.reverse()
									.join("-") + " 02:00:00";
						else if (
							!this.currentPurchaseInvoiceDateTemp &&
							this.currentPurchase.id == y.id
						)
							y.invoice_date = null;
						if (!y.invoice_date) {
							check++;
						}
					}
				}
				this.displayedPurchases[this.tmpNum].dateAll =
					check == 0 ? true : false;

				this.currentPurchase = null;
				this.currentPurchaseInvoiceDateTemp = null;
				this.$vs.notify({
					title: "Succès",
					text: "Date de facturation modifée avec succès.",
				});
				this.showDatePopup = false;

				let tmp = [...this.displayedPurchases];
				this.displayedPurchases = [];
				this.displayedPurchases = tmp;
				txt.innerHTML = "";
			} catch (e) {
				this.currentPurchase.invoice_date = this.currentPurchase.invoice_date
					? this.currentPurchase.invoice_date
					: null;
				//console.log(e);
				this.$vs.notify({
					title: "Echec",
					text: "Veuillez remplir la date correctement.",
				});
				this.showDatePopup = false;
			}
		},

		async saveInvoiceDateForAll() {
			let list = [];
			if (!this.tmpNumber) {
				for (let x of this.currentPurchases) {
					list.push(x.id);
				}
			} else {
				list =
					this.displayedPurchases[this.tmpNum].contracts[this.tmpNumber]
						.selected;
			}

			let txt = document.getElementById("txt");
			txt.innerHTML = "<b>Enregistrement en cours, veuillez patienter.</b>";

			try {
				await Purchase.updatePurchaseInvoiceDateForAll(
					list,
					this.currentPurchaseInvoiceDateTemp
				);

				await new Promise((resolve) => {
					for (let i = 0; i < this.currentPurchases.length; i++) {
						this.currentPurchases[i].invoice_date = this
							.currentPurchaseInvoiceDateTemp
							? this.currentPurchaseInvoiceDateTemp
									.split("/")
									.reverse()
									.join("-") + " 02:00:00"
							: null;
					}
					let check = 0;
					for (let x of this.displayedPurchases[this.tmpNum].contracts) {
						for (let y of x.detail) {
							if (
								this.currentPurchaseInvoiceDateTemp &&
								list.indexOf(y.id) > -1
							)
								y.invoice_date =
									this.currentPurchaseInvoiceDateTemp
										.split("/")
										.reverse()
										.join("-") + " 02:00:00";
							else if (
								!this.currentPurchaseInvoiceDateTemp &&
								list.indexOf(y.id) > -1
							)
								y.invoice_date = null;
							if (!y.invoice_date) {
								check++;
							}
						}
					}
					this.displayedPurchases[this.tmpNum].dateAll =
						check == 0 ? true : false;

					if (this.tmpNumber) {
						this.displayedPurchases[this.tmpNum].contracts[
							this.tmpNumber
						].selectAll = false;
						this.displayedPurchases[this.tmpNum].contracts[
							this.tmpNumber
						].selected = [];
					}
					this.currentPurchases = [];
					this.currentPurchase = null;
					this.currentPurchaseInvoiceDateTemp = null;
					this.$vs.notify({
						title: "Succès",
						text: "Date de facturation modifée avec succès.",
					});
					this.showDatePopup = false;
					this.showValidatePopup = false;
					let tmp = [...this.displayedPurchases];
					this.displayedPurchases = [];
					this.displayedPurchases = tmp;
					txt.innerHTML = "";
					resolve();
				});
			} catch (e) {
				//console.log(e);
				this.$vs.notify({
					title: "Echec",
					text: "Veuillez remplir la date correctement.",
				});
				return;
			}
		},

		select(num, number) {
			let select = document.getElementsByClassName(
				"selection" + num + "/" + number
			);
			if (!this.displayedPurchases[num].contracts[number].selectAll) {
				for (let i of this.displayedPurchases[num].contracts[number].detail) {
					this.displayedPurchases[num].contracts[number].selected.push(i.id);
				}
				this.displayedPurchases[num].contracts[number].selectAll = true;
				for (let x = 0; x < select.length; x++) {
					select[x].checked = true;
				}
			} else {
				this.displayedPurchases[num].contracts[number].selected = [];
				this.displayedPurchases[num].contracts[number].selectAll = false;
				for (let x = 0; x < select.length; x++) {
					select[x].checked = false;
				}
			}
		},
		selectValidate() {
			if (!this.selectAll) {
				for (let i of this.tmpValidateList) {
					this.selected.push(i.id);
				}
			} else {
				this.selected = [];
			}
		},
		validateList() {
			let tmpList = [];
			for (let i of this.tmpValidateList) {
				tmpList.push(i.id);
			}
			tmpList = tmpList.filter((id) => {
				return this.selected.indexOf(id) == -1;
			});
			this.currentPurchases = this.currentPurchases.filter((purchase) => {
				return tmpList.indexOf(purchase.id) == -1;
			});
			this.saveInvoiceDateForAll();
		},

		updatePurchase(purchase) {
			if (purchase.recurrence_id) {
				let propsData = {
					propsData: {
						objToRedirect: purchase,
						title:
							"Voulez-vous modifier l'achat original ou l'achat récurrent ?",
						optionOneText: "L'achat original",
						optionTwoText: "L'achat récurrent",
						isActive: true,
					},
				};

				/*
				 *  //console.log("propsData", propsData)
				 * Instancie la class SocietyInfoPopup pour mount sur la balise div principale
				 */
				let ComponentClass = Vue.extend(ValidationPopup);
				/*
				 * //console.log("ComponentClass")
				 * //console.log(ComponentClass)
				 */
				let validationPopup = new ComponentClass(propsData);
				validationPopup.$mount();
				validationPopup.$on("option-one", (purchase) => {
					this.updateMainPurchase(purchase);
				});
				validationPopup.$on("option-two", (purchase) => {
					this.updateRecurringPurchase(purchase);
				});
				this.$refs.popupContainer.appendChild(validationPopup.$el);
				/*
				 * //console.log("this.$refs.popupContainer")
				 * //console.log(this.$refs.popupContainer)
				 */
			} else {
				this.updateMainPurchase(purchase);
			}
		},

		updateMainPurchase(purchase) {
			//console.log("modify-purchase");
			this.$emit("modify-purchase", purchase);
		},

		updateRecurringPurchase(purchase) {
			//console.log("modify-recurring");
			this.$emit("modify-recurring", purchase);
		},

		renewPurchase(purchaseId) {
			this.$emit("renew-purchase", purchaseId);
		},

		togglePurchaseExpand(index) {
			this.$set(this.expandedPurchases, index, !this.expandedPurchases[index]);
		},

		toggleContractExpand(purchaseIndex, contractIndex) {
			const key = purchaseIndex + '-' + contractIndex;
			this.$set(this.expandedContracts, key, !this.expandedContracts[key]);
		},
	},
};
</script>

<style>
.thead-service > div > div > table > thead > tr {
	background-color: #0c293d;
	color: white;
}
div.content-tr-expand {
	padding: 0;
}
.center {
	justify-content: center;
}
.myBtn {
	background-color: transparent !important;
}
.myBtn:hover {
	box-shadow: none !important;
	background-color: orange !important;
}
.myBtnPrimary {
	color: rgba(var(--vs-primary), 1) !important;
	background-color: transparent !important;
}
.myBtnPrimary:hover {
	box-shadow: none !important;
	background-color: rgba(var(--vs-primary), 1) !important;
}
#provider-table > .con-tablex.vs-table--content {
	overflow: auto;
	max-height: calc(100vh - 455px);
}

.expand-row {
	background-color: #f8f9fa;
}

.expand-row td {
	border: none !important;
}

.expand-btn {
	padding: 2px 4px !important;
	min-width: auto !important;
	height: 24px !important;
}
</style>
